import { createStyles, makeStyles, Theme, Typography } from '@material-ui/core'
import { memo, ReactText } from 'react'
import {
  buildStyles,
  CircularProgressbarWithChildren,
} from 'react-circular-progressbar'
import { NotificationType } from 'services/APIs/InternalAPI/internal-api.contracts'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    avatar: {
      '& svg': {
        // maxWidth: `${theme.spacing(5)}px`,
        // width: '100%',
      },
    },
    info: {
      '& .CircularProgressbar-path': {
        stroke: `${theme.palette.primary.main} !important`,
      },
      '& .CircularProgressbar-text': {
        fill: `${theme.palette.primary.main} !important`,
      },
      '& .CircularProgressbar-trail': {
        stroke: `${theme.palette.divider} !important`,
      },
      width: '100%',
      // width: '3em !important',
    },
    danger: {
      '& .CircularProgressbar-path': {
        stroke: `${theme.palette.error.main} !important`,
      },
      '& .CircularProgressbar-trail': {
        stroke: `${theme.palette.error.main} !important`,
      },
      '& .CircularProgressbar-text': {
        fill: `${theme.palette.error.main} !important`,
      },
      // width: '3em !important',
    },
  })
)

const CircularProgressBarWithText = (props: {
  progress?: number
  notificationType: NotificationType
  text?: ReactText
  rootClassName?: string
}) => {
  const classes = useStyles()

  return (
    <CircularProgressbarWithChildren
      value={props.progress}
      className={
        //notification type are comming wrong from the api
        props.notificationType === NotificationType.Info ||
        (props.notificationType as unknown as number) === 1
          ? classes.info
          : classes.danger
      }
      // className={`is-${NotificationType[props.notificationType]
      //   }`}
      styles={buildStyles({
        pathTransition:
          props.progress === 0 ? 'none' : 'stroke-dashoffset 0.5s ease 0s',
        // textSize: '28px',
        strokeLinecap: 'butt',
      })}
      classes={{
        root: props.rootClassName,
        background: '',
        trail: 'CircularProgressbar-trail',
        path: 'CircularProgressbar-path',
        text: 'CircularProgressbar-text',
      }}
    >
      <Typography variant="caption" color="textSecondary">
        {props.text || (props.progress?.toFixed(0) || '0') + '%'}
      </Typography>
    </CircularProgressbarWithChildren>
  )
}

export default memo(CircularProgressBarWithText)
